<template>
  <!-- Coming soon page-->
  <div class="misc-wrapper">

    <div class="misc-inner p-2 p-sm-3">
      <div class="w-100 text-center">
        <h1 class="mb-1">{{ $t("We are launching soon") }} </h1>

        <!-- form -->
       
        <component :is="imgUrl" />
      </div>
    </div>
  </div>
  <!-- / Coming soon page-->
</template>

<script>
/* eslint-disable global-require */
import { BLink, BForm, BFormInput, BButton, BImg } from "bootstrap-vue";
import VuexyLogo from "@core/layouts/components/Logo.vue";
import store from "@/store/index";
import comingsoon from "@/assets/images/pages/coming-soon.svg";
import comingsoondark from "@/assets/images/pages/coming-soon-dark.svg";

export default {
  components: {
    VuexyLogo,
    BLink,
    BForm,
    BButton,
    BFormInput,
    BImg,
    comingsoon,
    comingsoondark,
  },
  data() {
    return {};
  },
  computed: {
    imgUrl() {
      if (store.state.appConfig.layout.skin === "dark") {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties

        return "comingsoondark";
      }
      return "comingsoon";
    },
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/pages/page-misc.scss";
</style>
